<div class="page-container">
    <div class="breadcrumb-menu">
        <div
            data-cy="sys-status-comm-breadcrumb-comm"
            (click)="onGoBack.emit()"
        >
            {{ "system-status.page-title.comms.long" | translate }}
        </div>
        {{ "/" }}
        <div
            data-cy="sys-status-comm-breadcrumb-selected-comm"
            class="breadcrumb-menu active"
        >
            {{ "system-status.page-title.comms.long" | translate }}
            {{ " " + (index + 1) }}
        </div>
    </div>
    <div data-cy="sys-status-selected-comm-title" class="page-title">
        {{ "system-status.page-title.comms.long" | translate }}
        {{ " " + (index + 1) }}
    </div>
    <div class="selected-comms-wrapper">
        <div class="status-container">
            <div class="status">
                <div
                    class="status-wrapper"
                    [ngClass]="{
                        'alarm-font':
                            getIcon(selectedComm.run) === 'status-error',
                    }"
                >
                    {{ "system-status.comms.run" | translate }}
                    <mat-icon
                        *ngIf="isReceivingData"
                        data-cy="sys-status-selected-comm-run-icon"
                        svgIcon="{{ getIcon(selectedComm.run) }}"
                        class="icon"
                    />
                    <div *ngIf="!isReceivingData" class="disconnected-line"></div>
                </div>
                <div
                    class="status-wrapper"
                    [ngClass]="{
                        'alarm-font':
                            getIcon(selectedComm.initialized) ===
                            'status-error',
                    }"
                >
                    {{ "system-status.comms.initialized" | translate }}
                    <mat-icon
                        *ngIf="isReceivingData"
                        data-cy="sys-status-selected-comm-init-icon"
                        svgIcon="{{ getIcon(selectedComm.initialized) }}"
                        class="icon"
                    />
                    <div *ngIf="!isReceivingData" class="disconnected-line"></div>
                </div>
                <div
                    class="status-wrapper"
                    [ngClass]="{
                        'alarm-font':
                            getIcon(selectedComm.files) === 'status-error',
                    }"
                >
                    {{ "system-status.comms.files" | translate }}
                    <mat-icon
                        *ngIf="isReceivingData"
                        data-cy="sys-status-selected-comm-files-icon"
                        svgIcon="{{ getIcon(selectedComm.files) }}"
                        class="icon"
                    />
                    <div *ngIf="!isReceivingData" class="disconnected-line"></div>
                </div>

                <div
                    class="status-wrapper"
                    [ngClass]="{
                        'alarm-font':
                            getIcon(selectedComm.fieldNetA) === 'status-error',
                    }"
                >
                    {{ "system-status.comms.fieldNetA" | translate }}
                    <mat-icon
                        *ngIf="isReceivingData"
                        data-cy="sys-status-selected-comm-fieldnet-a-icon"
                        svgIcon="{{ getIcon(selectedComm.fieldNetA) }}"
                        class="icon"
                    />
                    <div *ngIf="!isReceivingData" class="disconnected-line"></div>
                </div>
                <div
                    class="status-wrapper"
                    [ngClass]="{
                        'alarm-font':
                            getIcon(selectedComm.fieldNetB) === 'status-error',
                    }"
                >
                    {{ "system-status.comms.fieldNetB" | translate }}
                    <mat-icon
                        *ngIf="isReceivingData"
                        data-cy="sys-status-selected-comm-fieldnet-b-icon"
                        svgIcon="{{ getIcon(selectedComm.fieldNetB) }}"
                        class="icon"
                    />
                    <div *ngIf="!isReceivingData" class="disconnected-line"></div>
                </div>
            </div>
        </div>
        <div class="ports-container">
            <div class="ports-wrapper">
                <div *ngFor="let port of selectedComm.ports; index as i">
                    <app-ports-status-indicator
                        [isReceivingData]="isReceivingData"
                        [index]="i"
                        [port]="port"
                    ></app-ports-status-indicator>
                </div>
            </div>
        </div>
    </div>
</div>
